module.exports = __webpack_public_path__ + "img/section3_icon2.d0c2cdf4.png";